import React from 'react';
import { Text, DesktopWrap, UnsavedChangesDiv } from './Notifications.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import AlertCircleWarning from 'src/assets/images/AlertCircleWarning.svg';
//import Button from 'src/common/components/button/Button';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useTranslation } from 'react-i18next';

const UnsavedChanges = ({
    onClose,
    onDiscard,
    continueText,
    fromSettingsClose,
    fromPriceOverride,
}) => {
    const { t: translation } = useTranslation();
    return (
        <>
            <Popup
                title={
                    fromPriceOverride
                    ? translation('equity.unsavedChanges.priceOverrideTitle')
                    : translation('equity.unsavedChanges.title')
                }
                onClose={fromSettingsClose ? fromSettingsClose : onClose}
                img={fromPriceOverride ? AlertCircleWarning : AlertCircleOutline}
                id={'equity-common-unsavedChanges-popup'}
                isUnsavedPage={true}
            >
                <UnsavedChangesDiv divHeight={'140px'}>
                    <Text
                        flexGrow={'1'}
                        height={'auto'}
                        font={'14px Avenir Next World'}
                        lineHeight={'20px'}
                    >
                        {
                            fromPriceOverride
                            ? translation('equity.unsavedChanges.priceOverrideWarningMessage')
                            : translation('equity.unsavedChanges.warningMessage')
                        }
                    </Text>
                    <DesktopWrap flexDirection="row-reverse">
                        <Button
                          id={'equity-notification-unsavedchanges-okbutton'}
                           
                            show={true}
                            width={'308px'}
                            height={'38px'}
                            variant={ButtonStyles?.primary}
                           // primary={true}
                            borderRadius={'19px'}
                            margin={'5px 0 5px 5px'}
                            fontSize={'15px'}
                            fontFamily={'AvenirNextWorld Demi'}
                            clicked={onClose}
                        >
                            <div style={{ whiteSpace: 'nowrap' }}>
                                {continueText
                                    ? continueText
                                    : translation(
                                          'equity.unsavedChanges.continueEditingBtn'
                                      )}
                            </div>
                        </Button>

                        <Button
                        id={'equity-notification-unsavedchanges-discard'}
                            show={true}
                            //discard={true}
                            variant={ButtonStyles.discard}
                            width={'308px'}
                            height={'38px'}
                            borderRadius={'19px'}
                            margin={'5px 0 5px 5px'}
                            fontSize={'15px'}
                            fontFamily={'AvenirNextWorld Demi'}
                            clicked={onDiscard}
                        >
                            <div style={{ whiteSpace: 'nowrap' }}>
                                {translation(
                                    'equity.unsavedChanges.discardChangesAndExitBtn'
                                )}
                            </div>
                        </Button>
                    </DesktopWrap>
                </UnsavedChangesDiv>
            </Popup>
        </>
    );
};

export default UnsavedChanges;
